module.exports = __webpack_public_path__ + "static/media/vidInfoImage.b440534a.jpg";